import { FC } from 'react';
import { Tooltip, Image } from '@heroui/react';

interface CountryFlagProps {
  countryCode?: string;
  countryName?: string;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  showTooltip?: boolean;
}

export const CountryFlag: FC<CountryFlagProps> = ({
  countryCode,
  countryName,
  size = 'sm',
  showTooltip = true,
}) => {
  if (!countryCode) return null;

  const sizeMap = {
    sm: { width: 16, height: 12, minWidth: 16, minHeight: 12 },
    md: { width: 20, height: 15, minWidth: 20, minHeight: 15 },
    lg: { width: 24, height: 18, minWidth: 24, minHeight: 18 },
  };

  const { width, height, minWidth, minHeight } = sizeMap[size];
  const flagUrl = `/images/country-flags/${countryCode.toLowerCase()}.png`;

  const flag = (
    <Image
      src={flagUrl}
      alt={countryName || countryCode}
      width={width}
      height={height}
      className="object-cover rounded-sm"
      style={{ minWidth, minHeight }}
    />
  );

  if (showTooltip && countryName) {
    return (
      <Tooltip content={countryName}>
        {flag}
      </Tooltip>
    );
  }

  return flag;
}; 